module.exports = __webpack_public_path__ + "img/Afri Schoedon.aea24c7f.jpg";